import { useMemo, useState, createContext } from 'react'

export const SelectContext = createContext()

const SelectProvider = ({ children }) => {
  const [selected, setSelected] = useState([])

  const selectedMap = useMemo(() => selected.reduce((acc, i) => {
    acc[i.id] = true

    return acc
  }, {}), [selected])

  return (
    <SelectContext.Provider value={{ selected, selectedMap, setSelected }}>
      {children}
    </SelectContext.Provider>
  )
}

export default SelectProvider
